export enum LogLevel {
    Error = 0,
    Warning = 1,
    Info = 2,
    Verbose = 3,
}

export interface Configuration {
    auth?: {
        clientId?: string;
        authority?: string;
        redirectUri?: string;
        postLogoutRedirectUri?: string;
    };
    cache?: {
        cacheLocation?: string;
        storeAuthStateInCookie?: boolean;
    };
    system?: {
        allowNativeBroker?: boolean;
        loggerOptions?: {
            loggerCallback?: (level: LogLevel, message: string, containsPii: boolean) => void;
        };
    };
}
